import axios from "axios";
import getDynamicBaseUrl from "utils/urlHelper";
const instance = axios.create({
  baseURL: getDynamicBaseUrl(),
});

export default instance;